import { render, staticRenderFns } from "./balanceApi.vue?vue&type=template&id=570475af&"
import script from "./balanceApi.vue?vue&type=script&lang=js&"
export * from "./balanceApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports